import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUserAddComponent } from "./med-icon-user-add.component";

@NgModule({
  declarations: [
    MedIconUserAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUserAddComponent,
  ],
})
export class MedIconUserAddModule { }
